<!-- Plan Card Component Template -->
<!-- Requirements: 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 9.1, 9.2, 9.3, 10.1, 10.2 -->

<mat-card class="plan-card" [@fadeIn]>
  <!-- Card Header with Plan Name and Status Badge (Requirements 3.1, 3.2, 9.1, 9.2) -->
  <mat-card-header>
    <mat-card-title>Plano #{{ plan.id }}</mat-card-title>
    <div class="header-actions">
      <mat-chip [color]="getStatusColor(plan.active)">
        {{ getStatusLabel(plan.active) }} 
      </mat-chip>
      <button mat-icon-button [matMenuTriggerFor]="cardMenu" aria-label="Mais ações" (click)="$event.stopPropagation()">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-menu #cardMenu="matMenu">
    <button mat-menu-item (click)="onViewDetails()">
      <mat-icon>visibility</mat-icon>
      <span>Ver Detalhes</span>
    </button>
    <button mat-menu-item (click)="onViewPayments()">
      <mat-icon>receipt_long</mat-icon>
      <span>Ver Pagamentos</span>
    </button>
    <ng-container *ngIf="plan.active">
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onToggleAutoRenew($event)" [disabled]="isUpdatingAutoRenew()">
        <mat-icon>{{ isUpdatingAutoRenew() ? 'hourglass_empty' : 'autorenew' }}</mat-icon>
        <span>{{ isUpdatingAutoRenew() ? 'Atualizando...' : (plan.autoRenew ? 'Desativar Renovação Auto.' : 'Ativar Renovação Auto.') }}</span>
      </button>
    </ng-container>
  </mat-menu>

  <mat-card-content>
    <!-- Plan Info Grid: Items count and Package Type (Requirements 3.1, 3.3) -->
    <div class="plan-info-grid">
      <div class="info-item">
        <mat-icon>inventory</mat-icon>
        <span>{{ plan.items?.length || 0 }} itens</span>
      </div>
      <div class="info-item" *ngIf="plan.packageType">
        <mat-icon>category</mat-icon>
        <span>{{ plan.packageType }}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Financial Summary (Requirements 3.5, 3.6) -->
    <div class="financial-summary">
      <div class="summary-row">
        <span class="label">CPF/CNPJ:</span>
        <span class="value">{{ plan.cpfcnpj || 'N/A' }}</span>
      </div>
      <div class="summary-row" *ngIf="plan.payerCnpj">
        <span class="label">Pagador:</span>
        <span class="value">{{ plan.payerCnpj }}</span>
      </div>
      <div class="summary-row">
        <span class="label">Renovação Automática:</span>
        <span class="value auto-renew-status" [class.active]="plan.autoRenew">
          <mat-icon>{{ plan.autoRenew ? 'autorenew' : 'block' }}</mat-icon>
          {{ plan.autoRenew ? 'Ativada' : 'Desativada' }}
        </span>
      </div>
    </div>
  </mat-card-content>

  <!-- Action Buttons (Requirements 10.1, 10.2) -->
  <mat-card-actions>
    <button mat-button color="primary" (click)="onViewDetails()" aria-label="Ver detalhes do plano">
      <mat-icon>visibility</mat-icon>
      Ver Detalhes
    </button>
    <button mat-button color="accent" (click)="openUpgradeOptions()" [disabled]="!plan.active" aria-label="Ver opções de upgrade">
      <mat-icon>upgrade</mat-icon>
      Ver Upgrades
    </button>
  </mat-card-actions>
</mat-card>
